/* eslint-disable */

import axios from 'axios';
import {
  promised
} from 'q';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    categoryList: {},
    createCatgoryListData: {},
    updateCatgoryListData: {},
    deleteCatgoryListData: {},
    categoryDetailsByIdData: {},
    updateCatgoryBycourseData: {},
    UpdateCategoryIndex: {},
    quizAnimationData: {},
    quizAnimationByIdData: {},
    createQuizAnimationData: {},
    updateQuizAnimationData: {},
    deleteQuizAnimationData: {},
    getCategoriesListState:{}
  },
  mutations: {
    quizAnimationMutation(state, value) {
      state.quizAnimationData = value;
    },
    quizAnimationByIdMutation(state, value) {
      state.quizAnimationByIdData = value;
    },
    createQuizAnimationListMutation(state, value) {
      state.createQuizAnimationData = value
    },
    updateQuizAnimationListMutation(state, value) {
      state.updateQuizAnimationData = value
    },
    deleteQuizAnimationListMutation(state, value) {
      state.deleteQuizAnimationData = value
    },
    categoryListMut(state, value) {
      state.categoryList = value;
    },
    categoryDetailsByIdMutation(state, value) {
      state.categoryDetailsByIdData = value
    },
    createCatgoryListMutation(state, value) {
      state.createCatgoryListData = value
    },
    updateCatgoryListMutation(state, value) {
      state.updateCatgoryListData = value
    },
    deleteCatgoryListMutation(state, value) {
      state.deleteCatgoryListData = value
    },
    updateCategoryByCourseMutation(state, value) {
      state.updateCatgoryBycourseData = value
    },
    UPDATE_CATEGORY_INDEX(state, value) {
      state.UpdateCategoryIndex = value
    },
    getCategoriesListMuatation(state, value) {
      state.getCategoriesListState = value
    },
  },
  actions: {
    getCategoriesListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('courses/admin/category/').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('getCategoriesListMuatation', response)
            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch((error) => {
            // console.log(error);
            reject(error);
          });
      });
    },
    getQuizAnimationList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz-banner/').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('quizAnimationMutation', response.data.data.results)
            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch((error) => {
            // console.log(error);
            reject(error);
          });
      });
    },
    getQuizAnimationListById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz-banner/' + payload.id + '/').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('quizAnimationByIdMutation', response.data.data)
            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch((error) => {
            // console.log(error);
            reject(error);
          });
      });
    },
    createNewQuizAnimationList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/quiz-banner/', payload).then((response) => {
            context.commit('createQuizAnimationListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateQuizAnimationListById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/quiz-banner/' + payload.id + '/', payload.data).then((response) => {
            context.commit('updateQuizAnimationListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteQuizAnimationById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + '/quizzes/admin/quiz-banner/'
        axios.delete(url + payload.id + '/').then((response) => {
            context.commit('deleteQuizAnimationListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getCategoryListActn(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('courses/admin/category/').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('categoryListMut', response.data.data)
            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch((error) => {
            // console.log(error);
            reject(error);
          });
      });
    },
    getCategoryDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + 'courses/admin/category/'
        axios.get(url + payload.id + '/').then((response) => {
            context.commit('categoryDetailsByIdMutation', response.data)
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createNewCategoryList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/category/', payload, {
            headers: {
              'Content-Type': null
            }
          }).then((response) => {
            context.commit('createCatgoryListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateCategoryListById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + 'courses/admin/category/'
        let id = payload.data.id;
        axios.patch(url + id + '/', payload.data.formdata, {
            headers: {
              'Content-Type': null
            }
          }).then((response) => {
            context.commit('updateCatgoryListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteCategoryListById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + 'courses/admin/category/'
        axios.delete(url + payload.id + '/', payload).then((response) => {
            context.commit('deleteCatgoryListMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateCategoryByCourse(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('courses/admin/category/course/update/', payload).then((response) => {
            context.commit('updateCategoryByCourseMutation', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    UpdateCategoryIndex(context, payload) {
      let id = payload.data.id;
      let url = baseURL + "courses/admin/category/" + id + "/index/";
      return new Promise((resolve, reject) => {
        axios.patch(url, payload.data.data).then((response) => {
            context.commit('UPDATE_CATEGORY_INDEX', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    getQuizAnimationState: state => state.quizAnimationData,
    getQuizAnimationByIdState: state => state.quizAnimationByIdData,
    getCategoryListState: state => state.categoryList,
    getcategoryDetailsByIdDataState: state => state.categoryDetailsByIdData,
    getcreateCategorylistState: state => state.createCatgoryListData,
    getupdateCategorylistState: state => state.updateCatgoryListData,
    getdeleteCategorylistState: state => state.deleteCatgoryListData,
    getCategoriesListGetters: state => state.getCategoriesListState
  }
}
